import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Box,
    Grid,
    Switch,
    FormControlLabel,
    TextField,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { GetActivitiesDataAPI, GetActivityDataAPI, GetBonosDataAPI, GetGruopDataAPI, GetPointsDataAPI } from '../../Conections/AcademicConection';

// Datos de ejemplo para la actividad
const actividadEjemplo = {
    id: '0',
    nombre: '',
    descripcion: '',
    peso: 0,
    fecha: '',
    activa: true,
    subactividades: [
        { id: '0', nombre: '', peso: 0, activa: true },
    ],
    puntos: [
        { id: '0', nombre: '', valor: 0 },
    ],
    bonos: [
        { id: '0', nombre: '', valor: 0, activo: true },
    ]
};

let grupoEjemplo = {
    id: '',
    nombre: '',
    descripcion: '',
    estado: true,
};

function ActivityShow() {

    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [grupo, setGrupo] = useState(grupoEjemplo);
    const [actividad, setActividad] = useState(actividadEjemplo);
    const [actividadTitle, setActividadTitle] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [itemAEliminar, setItemAEliminar] = useState(null);
    const [tipoItemAEliminar, setTipoItemAEliminar] = useState('');
    const [busquedaSubactividades, setBusquedaSubactividades] = useState('');
    const [busquedaPuntos, setBusquedaPuntos] = useState('');
    const [busquedaBonos, setBusquedaBonos] = useState('');

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/showactivity/:id");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
                else {
                    let Activity = await GetActivityDataAPI(getToken(), getCompany(), params["id"]);
                    let Activities = await GetActivitiesDataAPI(getToken(), getCompany(), Activity["group"], params["id"]);
                    let Points = await GetPointsDataAPI(getToken(), getCompany(), params["id"]);
                    let Bonos = await GetBonosDataAPI(getToken(), getCompany(), params["id"]);
                    let Gruop = await GetGruopDataAPI(getToken(), getCompany(), Activity["group"]);

                    let grupoC = grupo;
                    grupoC["id"] = Gruop["gruop"]["id"];
                    grupoC["nombre"] = Gruop["gruop"]["name"];
                    grupoC["descripcion"] = Gruop["gruop"]["descripcion"];
                    grupoC["estado"] = Gruop["gruop"]["show"] === 1;
                    setGrupo(grupoC);

                    let actividadChange = actividad;
                    actividadChange["id"] = Activity["id"];
                    actividadChange["group"] = Activity["group"];
                    setActividadTitle(Activity["name"]);
                    actividadChange["nombre"] = Activity["name"];
                    actividadChange["descripcion"] = Activity["description"];
                    actividadChange["peso"] = Activity["weigth"];
                    actividadChange["fecha"] = Activity["date"];
                    actividadChange["activa"] = Activity["show"] === 1;
                    actividadChange["principal"] = Activity["principal"];

                    const listActivities = Activities.map(Activity => ({
                        id: Activity.id,
                        nombre: Activity.name,
                        group: Activity.group,
                        peso: Activity.weigth,
                        fecha: Activity.date,
                        activa: (Activity.show === 1)
                    }));
                    actividadChange["subactividades"] = listActivities;

                    const listPoint = Points.map(Point => ({
                        id: Point.id,
                        nombre: Point.text,
                        valor: Point.weigth,
                    }));
                    actividadChange["puntos"] = listPoint;

                    const listBono = Bonos.map(Bono => ({
                        id: Bono.id,
                        nombre: Bono.name,
                        valor: Bono.value,
                        activo: Bono.show === 1
                    }));
                    actividadChange["bonos"] = listBono;

                    setActividad(actividadChange);
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [params, actividad, getCompany, getToken, goTo, actividadTitle]);


    const handleEliminarItem = (item, tipo) => {
        setItemAEliminar(item);
        setTipoItemAEliminar(tipo);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setItemAEliminar(null);
        setTipoItemAEliminar('');
    };

    const confirmarEliminarItem = () => {
        if (tipoItemAEliminar === 'subactividad') {
            setActividad(prevActividad => ({
                ...prevActividad,
                subactividades: prevActividad.subactividades.filter(sub => sub.id !== itemAEliminar.id)
            }));
        } else if (tipoItemAEliminar === 'punto') {
            setActividad(prevActividad => ({
                ...prevActividad,
                puntos: prevActividad.puntos.filter(punto => punto.id !== itemAEliminar.id)
            }));
        } else if (tipoItemAEliminar === 'bono') {
            setActividad(prevActividad => ({
                ...prevActividad,
                bonos: prevActividad.bonos.filter(bono => bono.id !== itemAEliminar.id)
            }));
        }
        handleCloseDialog();
    };

    const handleCalificarItem = (item, tipo) => {
        if (tipo === "bono") {
            goTo("/academic/bonoupone/" + actividad["id"] + "/" + item["id"]);
        }
    };

    const handleEditarItem = (item, tipo) => {
        if (tipo === "subactividad") {
            goTo("/academic/editactivity/" + actividad["group"] + "/" + item.id);
        }
        else {
            if (tipo === "punto") {
                goTo("/academic/updatepoint/" + actividad["id"] + "/" + item.id);
            }
            else {
                console.log(`Editando ${tipo}: ${item.nombre}`);
            }
        }
        // Aquí iría la lógica para abrir un formulario de edición
    };

    const handleVerItem = (item, tipo) => {
        if (tipo === "subactividad") {
            goTo("/academic/showactivity/" + item.id);
        }
        else {
            console.log(`Viendo ${tipo}: ${item.nombre}`);
        }
    };

    const handleVerResultados = () => {
        goTo(`/academic/gradeshow/${actividad.id}`);
    };

    const handleSubirNotas = () => {
        goTo(`/academic/gradeup/${actividad.id}`);
    };

    const handleSubirNotasPorGrupo = () => {
        goTo(`/academic/gradeupone/${actividad.id}`);
    };

    const handleCrearPunto = () => {
        goTo(`/academic/createpoint/${actividad.id}`);
    };

    const handleCrearBono = () => {
        goTo(`/academic/createbono/${actividad.id}`);
    };

    const handleCrearSubactividad = () => {
        goTo("/academic/createactivity/" + actividad.group + "/" + actividad.id);
    };

    const filtrarSubactividades = () => {
        return actividad.subactividades.filter(sub =>
            sub.nombre.toLowerCase().includes(busquedaSubactividades.toLowerCase())
        );
    };

    const filtrarPuntos = () => {
        return actividad.puntos.filter(punto =>
            punto.nombre.toLowerCase().includes(busquedaPuntos.toLowerCase())
        );
    };

    const filtrarBonos = () => {
        return actividad.bonos.filter(bono =>
            bono.nombre.toLowerCase().includes(busquedaBonos.toLowerCase()) ||
            (bono.activo ? 'activo' : 'inactivo').includes(busquedaBonos.toLowerCase())
        );
    };

    const handleEditar = () => {
        goTo("/academic/editactivity/" + actividad["group"] + "/" + actividad["id"]);
    };

    const handleEditarG = () => {
        goTo("/academic/editgroup/" + actividad["group"]);
    };

    const handleGrupo = () => {
        goTo("/academic/showgroup/" + actividad["group"]);
    };

    const handlePrincipal = () => {
        goTo("/academic/showactivity/" + actividad["principal"]);
    };

    return (
        <Container component="main" maxWidth="md">
            <Typography component="h1" variant="h4" gutterBottom sx={{ mt: 4, mb: 2, textAlign: 'center' }}>
                Detalles de la Actividad
            </Typography>

            <Grid container spacing={3}>
                {/* Tarjeta de Información del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Información del Grupo
                            <IconButton onClick={() => handleEditarG(grupo.id)} color="primary">
                                <DriveFileRenameOutlineIcon />
                            </IconButton>
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography>Nombre: {grupo.nombre}</Typography>
                            <Typography>Descripción: {grupo.descripcion}</Typography>
                            <FormControlLabel
                                control={<Switch checked={grupo.estado} disabled />}
                                label={grupo.estado ? "Activo" : "Inactivo"}
                            />
                        </Box>
                    </Paper>
                </Grid>
                {/* Card de Información de la Actividad */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
                            {actividad["principal"] > 0 ?
                            <IconButton onClick={() => handlePrincipal()} color="primary">
                                <ArrowBackIosIcon />
                            </IconButton>
                            : <></>
                            }
                            <IconButton onClick={() => handleGrupo()} color="primary">
                                <PeopleOutlineIcon />
                            </IconButton>
                            Información de la Actividad
                            <IconButton onClick={() => handleEditar()} color="primary">
                                <DriveFileRenameOutlineIcon />
                            </IconButton>
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography><strong>Nombre:</strong> {actividadTitle}</Typography>
                            <Typography><strong>Descripción:</strong> {actividad.descripcion}</Typography>
                            <Typography><strong>Peso:</strong> {actividad.peso}%</Typography>
                            <Typography><strong>Fecha:</strong> {actividad.fecha}</Typography>
                            <FormControlLabel
                                control={<Switch checked={actividad.activa} disabled />}
                                label={actividad.activa ? "Activa" : "Inactiva"}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleVerResultados}
                                sx={{ mt: 2 }}
                            >
                                Ver Resultados
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleSubirNotas}
                                sx={{ mt: 2 }}
                            >
                                Subir notas
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSubirNotasPorGrupo}
                                sx={{ mt: 2 }}
                            >
                                Subir notas por grupos
                            </Button>
                        </Box>
                    </Paper>
                </Grid>

                {/* Card de Subactividades */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                            <Typography variant="h6" component="div">
                                Subactividades
                            </Typography>
                            <IconButton color="primary" onClick={handleCrearSubactividad} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Box>
                        {filtrarSubactividades().length > 0 ?
                            <div>
                                <TextField
                                    fullWidth
                                    label="Buscar subactividad"
                                    variant="outlined"
                                    value={busquedaSubactividades}
                                    onChange={(e) => setBusquedaSubactividades(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nombre</TableCell>
                                                <TableCell>Peso</TableCell>
                                                <TableCell>Estado</TableCell>
                                                <TableCell align="center">Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filtrarSubactividades().map((subactividad) => (
                                                <TableRow key={subactividad.id}>
                                                    <TableCell>{subactividad.nombre}</TableCell>
                                                    <TableCell>{subactividad.peso}%</TableCell>
                                                    <TableCell>
                                                        <Typography
                                                            style={{
                                                                color: subactividad.activa ? 'green' : 'red',
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {subactividad.activa ? "Activa" : "Inactiva"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton onClick={() => handleVerItem(subactividad, 'subactividad')} color="primary">
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                        <IconButton onClick={() => handleEditarItem(subactividad, 'subactividad')} color="primary">
                                                            <EditIcon />
                                                        </IconButton>
                                                        {/*<IconButton onClick={() => handleEliminarItem(subactividad, 'subactividad')} color="secondary">
                                                    <DeleteIcon />
                                                </IconButton>*/}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div> : <div></div>}
                    </Paper>
                </Grid>

                {/* Card de Puntos */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                            <Typography variant="h6" component="div">
                                Puntos de la Actividad
                            </Typography>
                            <IconButton color="primary" onClick={handleCrearPunto} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Box>
                        {filtrarPuntos().length > 0 ?
                            <div>
                                <TextField
                                    fullWidth
                                    label="Buscar puntos"
                                    variant="outlined"
                                    value={busquedaPuntos}
                                    onChange={(e) => setBusquedaPuntos(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nombre</TableCell>
                                                <TableCell>Valor</TableCell>
                                                <TableCell align="center">Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filtrarPuntos().map((punto) => (
                                                <TableRow key={punto.id}>
                                                    <TableCell>{punto.nombre}</TableCell>
                                                    <TableCell>{punto.valor}</TableCell>
                                                    <TableCell align="center">
                                                        <IconButton onClick={() => handleEditarItem(punto, 'punto')} color="primary">
                                                            <EditIcon />
                                                        </IconButton>
                                                        {/*<IconButton onClick={() => handleEliminarItem(punto, 'punto')} color="secondary">
                                                    <DeleteIcon />
                                                </IconButton>*/}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div> :
                            <div></div>}
                    </Paper>
                </Grid>

                {/* Card de Bonos */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                            <Typography variant="h6" component="div">
                                Bonos de la Actividad
                            </Typography>
                            <IconButton color="primary" onClick={handleCrearBono} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Box>
                        {filtrarBonos().length > 0 ?
                            <div>
                                <TextField
                                    fullWidth
                                    label="Buscar bonos"
                                    variant="outlined"
                                    value={busquedaBonos}
                                    onChange={(e) => setBusquedaBonos(e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nombre</TableCell>
                                                <TableCell>Valor</TableCell>
                                                <TableCell>Estado</TableCell>
                                                <TableCell align="center">Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filtrarBonos().map((bono) => (
                                                <TableRow key={bono.id}>
                                                    <TableCell>{bono.nombre}</TableCell>
                                                    <TableCell>{bono.valor}</TableCell>
                                                    <TableCell>
                                                        <Typography
                                                            style={{
                                                                color: bono.activo ? 'green' : 'red',
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {bono.activo ? "Activo" : "Inactivo"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton onClick={() => handleCalificarItem(bono, 'bono')} color="primary">
                                                            <UpgradeIcon />
                                                        </IconButton>
                                                        <IconButton onClick={() => handleEditarItem(bono, 'bono')} color="primary">
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton onClick={() => handleEliminarItem(bono, 'bono')} color="secondary">
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div> :
                            <div></div>
                        }
                    </Paper>
                </Grid>
            </Grid>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ textAlign: 'center' }}
            >
                <DialogContent>
                    <WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
                    <DialogTitle id="alert-dialog-title">
                        {`¿Está seguro de eliminar ${tipoItemAEliminar === 'subactividad' ? 'esta subactividad' :
                            tipoItemAEliminar === 'punto' ? 'este punto' : 'este bono'
                            }?`}
                    </DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                        {`Esta acción eliminará ${tipoItemAEliminar === 'subactividad' ? 'la subactividad' :
                            tipoItemAEliminar === 'punto' ? 'el punto' : 'el bono'
                            } "${itemAEliminar?.nombre}" de la actividad.`}
                        Esta acción no se puede deshacer.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={handleCloseDialog} variant="contained" color="primary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={confirmarEliminarItem}
                        variant="contained"
                        color="error"
                        autoFocus
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default ActivityShow;

